<template>
  <div class="live-back">
    <div class="live">
      <div class="content">
        <div class="left">
          <div class="player-box" v-if="liveType != -1">
            <img src="https://events.schneider-electric.cn/ciif2024/2024/live/replay.png" class="replayPoster" alt=""
              v-if="replay">
            <div class="player" id="J_prismPlayer" v-else />
            <!-- <img v-if="showPlayBtn" src="https://staticdn.ht-s.cn/se/ciif/2024/live/play.png" alt="" class="play"  @click="liveStart" /> -->
          </div>
          <div class="player-box" v-else>
            <img :src="reviewImg" class="player" alt="" />
          </div>
          <div class="live-info">
            <div class="info_left">
              <img src="https://staticdn.ht-s.cn/se/ciif/2024/live/schneider-logo.png" alt="" class="logo" />
              <div class="info">
                <div class="title">{{ liveInfo.name }}</div>
                <div class="people">
                  <img src="https://staticdn.ht-s.cn/se/ciif/2024/live/people.png" alt="" />
                  在线人数：{{ watchNumber }}
                </div>
              </div>
            </div>
            <div class="info_right">
              <a href="javascript:void(0)" @click="like">
                <svg t="1726122482402" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="14279" width="200" height="200">
                  <path
                    d="M217.1392 890.112v-460.8c0-18.6368-12.544-33.7408-28.0064-33.7408H129.3824c-28.8768 0-52.2752 28.2112-52.2752 62.976v402.3296c0 34.7648 23.3984 62.9248 52.2752 62.9248h59.7504c15.6672 0.0512 28.0064-15.0528 28.0064-33.6896zM278.528 899.5328V419.5328a24.2688 24.2688 0 0 1 18.1248-23.552c37.7344-9.6256 124.2112-44.1344 160.9728-161.9456 22.3744-103.168 46.7456-151.808 118.784-145.9712s76.8 75.9296 76.8 97.28v165.5296s-5.8368 25.2928 18.5344 27.2384 214.1184 0 214.1184 0 104.1408-1.7408 71.0656 127.5904c-28.7744 112.64-85.76 293.5296-100.1472 338.8416a101.2224 101.2224 0 0 1-12.7488 26.368c-13.9264 20.48-43.2128 52.9408-87.9616 52.9408H302.8992a24.3712 24.3712 0 0 1-24.3712-24.32z"
                    fill="#FF623E" p-id="14280"></path>
                </svg>
              </a>
              <span>{{ likeNumber }}</span>
            </div>
          </div>
          <!-- 移动端直播日程 -->
          <div class="right" v-if="clientWidth <= 750">
            <div class="share">
              <div class="btn" @click="shareLive" v-ga="{ event: 'trk', ec: 'agenda', ea: 'agenda', el: 'share' }">
                <img src="https://staticdn.ht-s.cn/se/ciif/2024/live/share.png" alt="" class="share-icon" />分享直播
              </div>
            </div>
            <div class="date-line">
              <div class="title">
                <img src="https://staticdn.ht-s.cn/se/ciif/2024/live/icon1.png" alt="" />
                今日直播日程
              </div>
              <el-scrollbar class="time-out">
                <div class="time-box" v-if="todaySchedule && todaySchedule.liveInfo.name">
                  <div class="dot"></div>
                  <div class="am">
                    <img class="icon" src="https://staticdn.ht-s.cn/se/ciif/2024/index/icon_module2_3.png" alt="" />
                    <div class="unit" v-for="(item, index) in todaySchedule.timeList.AM" :key="index">
                      <img class="icon-circle" src="https://staticdn.ht-s.cn/se/ciif/2024/index/icon_module2_2.png" />
                      <div class="time"> {{ item.time }} </div>
                      <div class="time-title" v-html="item.title"></div>
                      <div class="to-exam" v-if="item.question" @click="toExam(item.question)"
                        v-ga="{ event: 'trk', ec: 'agenda', ea: 'agenda', el: 'quiz', }">
                        参与问答赢积分
                        <img class="exam-icon" src="https://staticdn.ht-s.cn/se/ciif/2024/live/exam-arrow.png" alt="" />
                      </div>
                    </div>
                  </div>
                  <div class="pm">
                    <img class="icon" src="https://staticdn.ht-s.cn/se/ciif/2024/index/icon_module2_4.png" alt="" />
                    <div class="unit" v-for="(item, index) in todaySchedule.timeList.PM" :key="index">
                      <img class="icon-circle" src="https://staticdn.ht-s.cn/se/ciif/2024/index/icon_module2_2.png"
                        alt="" />
                      <div class="time"> {{ item.time }} </div>
                      <div class="time-title" v-html="item.title"></div>
                      <div class="to-exam" v-if="item.question" @click="toExam(item.question)"
                        v-ga="{ event: 'trk', ec: 'agenda', ea: 'agenda', el: 'quiz', }">
                        参与问答赢积分
                        <img class="exam-icon" src="https://staticdn.ht-s.cn/se/ciif/2024/live/exam-arrow.png" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </el-scrollbar>
            </div>
          </div>
          <!-- <div class="question" v-if="clientWidth > 750">
            <img src="https://staticdn.ht-s.cn/se/ciif/2024/live/to-question.png" alt="" class="to-question" @click="toExam" />
          </div>
          <div class="question" @click="toExam" v-else></div> -->
          <div class="interaction">
            <!-- 评论tab栏 -->
            <div class="tabs">
              <div :class="active === 0 ? 'tab-active tab' : 'tab'" @click="tabChange(0)"
                v-ga="{ event: 'trk', ec: 'interaction', ea: 'tab', el: 'chat', }">
                聊天互动
              </div>
              <div :class="active === 1 ? 'tab-active tab' : 'tab'" @click="tabChange(1)"
                v-ga="{ event: 'trk', ec: 'interaction', ea: 'tab', el: 'answer', }">
                专家解答
              </div>
              <!-- <div :class="active === 2 ? 'tab-active tab' : 'tab'" @click="tabChange(2)" v-ga="{ event: 'trk', ec: 'interaction', ea: 'tab', el: 'answer', }" >
                与我相关
              </div> -->
            </div>
            <!-- 评论区 -->
            <div v-loading="commentLoading" class="interaction-content">
              <div class="loadMore" v-if="loadMore">
                <i class="el-icon-loading"></i>
                加载中
              </div>
              <div class="comments" v-show="active === 0">
                <div class="comment-input">
                  <el-popover placement="top-start" width="240" trigger="click" v-model="liveInfo.emojiAlert">
                    <div class="emoji-list">
                      <div v-for="item in liveInfo.emojiList" :key="item.text" class="emoji-item"
                        @click="setEmojiComment(item.text)">
                        <img :src="item.url" alt="" />
                      </div>
                    </div>
                    <img slot="reference" src="https://staticdn.ht-s.cn/se/ciif/2024/live/emoji.png" alt=""
                      class="emoji-btn" />
                  </el-popover>

                  <input v-model="commentText" @keydown.enter="sendComment()" type="text" placeholder="请在此处输入您的评论" />
                  <el-button :loading="sendLoading" class="send" @click="sendComment()">发送</el-button>
                </div>
                <el-scrollbar class="comments-content">
                  <div class="zone-tip" v-if="list.length === 0">欢迎留言提问</div>
                  <div class="list">
                    <div :class="item.onlineUserId === userId ? 'myself-unit unit' : 'unit'"
                      v-for="(item, index) in list" :key="index">
                      <div class="info" v-if="item.onlineUserId !== userId">
                        <el-image fit="cover" v-if="false" :src="item.avatar" alt="" class="avatar"></el-image>
                        <img v-if="item.userType == 0" src="https://staticdn.ht-s.cn/se/ciif/2024/live/official.png"
                          alt="" class="admin" />
                        <img v-if="item.topFlag == 1" src="https://staticdn.ht-s.cn/se/ciif/2024/live/top.png" alt=""
                          class="top" />
                        <div class="name">{{ item.nickname }}</div>
                        <div class="time">
                          {{ $moment(item.chatTime * 1).format("yyyy/MM/DD HH:mm:ss") }}
                        </div>
                      </div>
                      <div class="info" v-else>
                        <div class="time">
                          {{ $moment(item.chatTime * 1).format("yyyy/MM/DD HH:mm:ss") }}
                        </div>
                        <div class="name">{{ item.nickname }}</div>

                        <img v-if="item.topFlag == 1" src="https://staticdn.ht-s.cn/se/ciif/2024/live/top.png" alt=""
                          class="top" />
                        <img v-if="item.userType == 0" src="https://staticdn.ht-s.cn/se/ciif/2024/live/official.png"
                          alt="" class="admin" />
                        <el-image fit="cover" v-if="false" :src="item.avatar" alt="" class="avatar"></el-image>
                      </div>
                      <div class="message">
                        <div class="text" v-html="getMessage(item.chatContent)"></div>
                      </div>
                    </div>
                  </div>
                </el-scrollbar>
              </div>
              <div class="topics" v-show="active === 1">
                <div class="topic-input">
                  <textarea v-model="topicText" @keydown.enter="sendTopic()" :placeholder="topicPlaceholder"></textarea>
                  <div class="topic-btns">
                    <el-button class="cancel" v-if="topicPlaceholder !== '请在此处输入您的问题'"
                      @click="replyCancel">取消回复</el-button>
                    <el-button :loading="sendLoading" class="send" @click="sendTopic()">发送</el-button>
                  </div>
                </div>
                <el-scrollbar class="topics-content">
                  <div class="zone-tip" v-if="topiclist.length === 0">欢迎留言提问</div>
                  <div class="list">
                    <div class="unit" v-for="(item, index) in topiclist" :key="index">
                      <div class="info">
                        <el-image fit="cover" v-if="item.avatar" :src="item.avatar" alt="" class="avatar"></el-image>
                        <el-image fit="cover" v-else
                          src="https://staticdn.ht-s.cn/se/ciif/2024/personal/icon_person.png" alt=""
                          class="avatar"></el-image>
                        <!-- <img v-if="item.is_admin" src="https://staticdn.ht-s.cn/se/ciif/2024/live/official.png" alt=""  class="admin" /> -->
                        <img v-if="item.isTop" src="https://staticdn.ht-s.cn/se/ciif/2024/live/top.png" alt=""
                          class="top" />
                        <div class="name">{{ item.creatorName }}</div>
                        <div class="time">
                          <!-- {{ item.createdAt.split("-").join("/") }} -->
                          {{ $moment(item.createdAt * 1000).format("yyyy/MM/DD HH:mm:ss") }}
                        </div>
                      </div>
                      <div class="message">
                        <div class="text" v-html="getMessage(item.content)"></div>
                        <!-- 去除回复功能 -->
                        <div class="reply" v-if="false" @click="replayTopic(item)">回复</div>
                      </div>
                      <div class="replies">
                        <div class="reply-unit" v-for="(sub, subIndex) in item.replies" :key="subIndex">
                          <img class="icon" src="https://staticdn.ht-s.cn/se/ciif/2024/live/icon2.png" alt="" />
                          <div class="reply-name">
                            <span class="user">{{ sub.replierName }} </span>
                            回复 {{ item.creatorName }}：
                          </div>
                          <div class="reply-message">
                            <div class="text" v-html="sub.content"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-scrollbar>
              </div>
              <div class="topics" v-show="active === 2">
                <el-scrollbar class="topics-content">
                  <div class="zone-tip" v-if="liveInfo.myTopics.length === 0">暂无相关解答</div>
                  <div class="list">
                    <div class="unit" v-for="(item, index) in liveInfo.myTopics" :key="index">
                      <div class="info">
                        <el-image fit="cover" :src="item.avatar" alt="" class="avatar"></el-image>
                        <img v-if="item.is_admin" src="https://staticdn.ht-s.cn/se/ciif/2024/live/official.png" alt=""
                          class="admin" />
                        <img v-if="item.top" src="https://staticdn.ht-s.cn/se/ciif/2024/live/top.png" alt=""
                          class="top" />
                        <div class="name">{{ item.username }}</div>
                        <div class="time">
                          {{ item.created_at.split("-").join("/") }}
                        </div>
                      </div>
                      <div class="message">
                        <div class="text" v-html="getMessage(item.message)"></div>
                      </div>
                      <div class="replies">
                        <div class="reply-unit" v-for="(sub, subIndex) in item.replies" :key="subIndex">
                          <img class="icon" src="https://staticdn.ht-s.cn/se/ciif/2024/live/icon2.png" alt="" />
                          <div class="reply-name">
                            <span class="user">{{ sub.username }} </span>
                            回复 {{ item.username }}：
                          </div>
                          <div class="reply-message">
                            <div class="text" v-html="sub.message"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-scrollbar>
              </div>
            </div>
          </div>
        </div>
        <!-- 右侧直播日程 -->
        <div class="right" v-if="clientWidth > 750">
          <div class="share">
            <!-- <img src="https://staticdn.ht-s.cn/se/ciif/2024/live/arrow-left.png" alt="" class="arrow" /> -->
            <div class="btn" @click="shareLive" v-ga="{ event: 'trk', ec: 'agenda', ea: 'agenda', el: 'share' }">
              分享直播<img :src="Res_Url + '/live/share.png'" alt="" class="share-icon" />
            </div>
            <!-- <img src="https://staticdn.ht-s.cn/se/ciif/2024/live/arrow-right.png" alt="" class="arrow" /> -->
          </div>
          <div class="date-line">
            <div class="title">
              <img src="https://staticdn.ht-s.cn/se/ciif/2024/live/icon1.png" alt="" />
              今日直播日程
            </div>
            <el-scrollbar class="time-out">
              <div class="time-box" v-if="todaySchedule && todaySchedule.liveInfo.name"> 
                <div class="dot"></div>
                <div class="am">
                  <img class="icon" src="https://staticdn.ht-s.cn/se/ciif/2024/index/icon_module2_3.png" alt="" />
                  <!-- v-for="(item, index) in todaySchedule.timeList.AM.filter((sub) => sub.content !== '')" -->
                  <div class="unit" v-for="(item, index) in todaySchedule.timeList.AM" :key="index">
                    <img class="icon-circle" src="https://staticdn.ht-s.cn/se/ciif/2024/index/icon_module2_2.png"
                      alt="" />
                    <div class="time"> {{ item.time }} </div>
                    <div class="time-title" v-html="item.title"></div>
                    <div class="to-exam" v-if="item.question" @click="toExam(item.question)"
                      v-ga="{ event: 'trk', ec: 'agenda', ea: 'agenda', el: 'quiz', }">
                      参与问答赢积分
                      <img class="exam-icon" src="https://staticdn.ht-s.cn/se/ciif/2024/live/exam-arrow.png" alt="" />
                    </div>
                  </div>
                </div>
                <div class="pm">
                  <img class="icon" src="https://staticdn.ht-s.cn/se/ciif/2024/index/icon_module2_4.png" alt="" />
                  <!-- v-for="(item, index) in todaySchedule.timeList.PM.filter((sub) => sub.content !== '')" -->
                  <div class="unit" v-for="(item, index) in todaySchedule.timeList.PM" :key="index">
                    <img class="icon-circle" src="https://staticdn.ht-s.cn/se/ciif/2024/index/icon_module2_2.png"
                      alt="" />
                    <div class="time"> {{ item.time }} </div>
                    <div class="time-title" v-html="item.title"></div>
                    <div class="to-exam" v-if="item.question" @click="toExam(item.question)"
                      v-ga="{ event: 'trk', ec: 'agenda', ea: 'agenda', el: 'quiz', }">
                      参与问答赢积分
                      <img class="exam-icon" src="https://staticdn.ht-s.cn/se/ciif/2024/live/exam-arrow.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </el-scrollbar>
          </div>
        </div>
      </div>
    </div>
    <!-- 弹窗答题 -->
    <transition name="el-fade-in">
      <div v-show="question_box_show" class="question_box">
        <div class="question">
          <div class="head">
            直播间小问答
            <!-- <i class="el-icon-circle-close" @click="boxClose"></i> -->
            <span class="question-close" @click="boxClose">×</span>
          </div>
          <div class="container">
            <div class="title">
              <img class="icon" src="https://staticdn.ht-s.cn/se/ciif/2024/exhibition/question_title_icon.png"
                alt="" />{{ question.topic }}
            </div>
            <el-radio-group v-if="question.Type === 'radio'" v-model="currentSelect">
              <el-radio v-for="(item, index) in question.option" :key="index" :label="index">{{ item.option_text
                }}</el-radio>
            </el-radio-group>
            <el-checkbox-group v-else v-model="currentSelect">
              <el-checkbox v-for="(item, index) in question.option" :key="index" :value="item" :label="index">{{
                item.option_text }}</el-checkbox>
            </el-checkbox-group>
            <div class="btns">
              <div class="confirm" @click="confirm">提交</div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <Rdialog :isRegister="islogin == false" :isIntegral="isIntegral" :integralText="integralText"
      :liveStatus="liveStatus" :canClose="false" @handleClose="handleClose"></Rdialog>
    <Qdialog :isOk="isOk" :isError="isError" :isSuccess="isSuccess" @handleClose="handleClose"
      @handleReset="handleReset" text="直播"></Qdialog>
    <SharePoster :imgSrc="posterImg" :isShow="posterShow" @closePoster="closePoster"></SharePoster>
  </div>
</template>

<script>
import mixSDKData from '@/assets/static/js/state.js'
import { Watch, Player, Chat, Topic, ChatContentType, Call, Menu, Message, Like, OnlineUser, Goods, LuckyDraw, LiveCountdown, Access } from '@/assets/static/sdk/sdk.js';
import emoji from "./emoji.js";
import agenda from "@/assets/json/agenda.json";
import Rdialog from "@/components/rdialog/index.vue";
import Qdialog from "@/components/qdialog/index.vue";
import SharePoster from "@/components/sharePoster/";
import { Res_Url } from "@/utils/ApiToken.js";
import {
  PersonnelMine,
  UserLiveInfo,
  GetLinkExamination,
  SubmitLinkExamination,
  GetLiveInfo,
  GetSharePoster,
  GetUserLogs,
  AddPoints,
  GetOnlineVisitorList,
} from "@/api";
export default {
  mixins: [mixSDKData({
    'eventNumber': Watch.eventNumber,
    'eventName': Watch.eventName,
    'userId': Watch.userId,
    'nickName': Watch.nickName,
    'watchNumber': Watch.watchNumber,
    'currentPlayType': Player.currentPlayType,
    'enableVideo': Player.enableVideo,
    'ChatList': Chat.chatList,
    'chatCheckFlag': Chat.chatCheckFlag,
    'topList': Chat.topList,
    'topicList': Topic.topicList,
    'topicFlag': Topic.topicFlag,
    'likeFlag': Like.likeFlag,
    'likeNumberFlag': Like.likeNumberFlag,
    'likeNumber': Like.likeNumber
  })],
  data() {
    return {
      Res_Url: Res_Url,
      commentLoading: true,
      // reviewImg: require('@/assets/index/img-review.png'),
      reviewImg: Res_Url + "/index/img-review.png",
      agenda: agenda,
      peopleNum: 999,
      active: 0,
      showPlayBtn: false,
      topiclist: [],
      usertopic: [],
      list: [],
      userChat: [],
      liveInfo: {
        // 直播名称
        name: "",
        // 直播状态
        status: false,
        // 浏览量
        viewNums: 0,
        liveAttr: "",
        // 直播封面
        liveImage: "",
        // 评论列表总页数
        commentPage: 1,
        // 评论列表
        comments: [],
        // 表情列表
        emojiList: emoji,
        emojiAlert: false,
        // 话题列表总页数
        topicPage: 1,
        // 话题列表
        topics: [],
        // 我的话题列表
        myTopics: [],
      },
      liveUserInfo: {
        user: {
          hash_id: "",
        },
      },
      sendLoading: false,
      // 评论文字
      commentText: "",
      // 话题文字
      topicText: "",
      topicPlaceholder: "请在此处输入您的问题",
      // 回复的话题id
      replayTopicId: "",
      loadMore: false,
      // 今日日程
      todaySchedule: null,
      question_box_show: false,
      question: {
        topic: "如下哪个不是施耐德电气 EcoStruxure™ 开放自动化平台的正确表述？",
        option: [
          "A.促进100%的工程效率",
          "B.实现100%的运营效率",
          "C.应对100%的未来挑战",
          "D.完成100%的工作任务",
        ],
        answer: 0,
      },
      isError: false,
      isOk: false,
      isSuccess: false,
      currentSelect: -1,
      liveId: null,
      posterImg: "",
      posterShow: false,
      topicFlag: false,
      isIntegral: false,
      integralText: "",
      liveStatus: true,
      replay: false,
      // 当前日程问题编号
      answerNo: -1,
      timer: null,
      liveType: 0
    };
  },
  components: {
    Rdialog,
    Qdialog,
    SharePoster,
  },
  mounted() {
    GetUserLogs({
      visitName: "页面访问-直播",
      visitType: 1,
      url: window.location.href,
      track: this.$route.query.track ? this.$route.query.track : 10366,
    });
    this.liveType = this.$route.query.livetype
    this.rePlay();

    // 直播时间限制
    // this.isLive();

    this.getTodaySchedule();
    this.commentsScroll();
  },
  beforeDestroy() {
    // 要进行函数卸载
    // window.removeEventListener("scroll", this.handleScroll);
    Watch.destroy();
    Access.destroy()
    clearInterval(this.timer);
  },
  watch: {
    ChatList(value, oldValue) {
      if (this.chatCheckFlag && this.userChat.length != 0) {
        this.list = JSON.parse(JSON.stringify(value))
        //查找是否审核通过
        if (this.list[this.list.length - 1].onlineUserId == this.userId) {
          this.userChat.forEach((item, i) => {
            if (item.chatContent == this.list[this.list.length - 1].chatContent) {
              this.userChat.splice(i, 1)
            }
          })
        }
        this.userChat.forEach((Uitem, i) => {
          let Tindex = this.list.findIndex(Liten => {
            return Uitem.chatTime < Liten.chatTime
          })
          this.list.splice(Tindex, 0, Uitem)
        })
      } else {
        this.list = JSON.parse(JSON.stringify(value))
      }
      const scrollBox = document.querySelector(".comments-content  .el-scrollbar__wrap");
      const COMMENT_BOX_HEIGHT = document.querySelector(".comments-content  .el-scrollbar__view").clientHeight;
      const LIVE_HEIGHT = document.querySelector(".comments-content  .el-scrollbar__wrap").clientHeight;
      scrollBox.scrollTop = COMMENT_BOX_HEIGHT - LIVE_HEIGHT + 40
      // console.log('消息',value);
    },
    topicList(value, oldValue) {
      if (this.topicFlag) {
        this.topiclist = JSON.parse(JSON.stringify(value))
      } else {
        this.topiclist = JSON.parse(JSON.stringify(value))
      }
      // console.log('消息',value);
    },
  },
  methods: {
    // 点赞
    like() {
      console.log('点赞 = ',this.likeNumberFlag,this.likeFlag,this);
      if (this.likeNumberFlag && this.likeFlag) {
        Like.dispatchLikeBar()
      }
    },
    // 开始播放
    liveStart() {
      // console.log(Mudu.Room.GetLiveStatus())
      if (window._player) {
        window._player.play();
        this.showPlayBtn = false;
      }
      // else{
      // }
    },
    isLive() {
      let livetype = this.$route.query.livetype ? Number(this.$route.query.livetype) - 1 : 0;
      let date = Date.now();

      if (livetype <= 3) {
        if (date < new Date(this.agenda[livetype].date.replace(/-/g, "/")).getTime()) { this.liveStatus = false }
      } else if (livetype == 4) {
        if (date < new Date("2023-09-24 11: 30: 00").getTime()) {
          this.liveStatus = false
        }

      }
    },
    rePlay() {
      let livetype = this.$route.query.livetype ? Number(this.$route.query.livetype) : 1;
      //  if (livetype == 3) {
      //   this.replay = true;
      //  }

    },
    // 获取今日日程
    async getTodaySchedule() {
      let that = this
      await GetLiveInfo({
        liveNo: this.$route.query.livetype ? Number(this.$route.query.livetype) : 1,
        track: this.$route.query.track ? this.$route.query.track : 10366,
      }).then((res) => {
        if (res.Status === 1) {
          that.liveId = res.Data.liveId;
          that.liveInfo.name = res.Data.LiveName;
          // let userInfo = that.getStorageSync('1830906985742336' + '08nU8WouBO' + '-token')
          // if (userInfo && userInfo.accessToken) {
          //   // 获取当前时间的时间戳
          //   let now = new Date().getTime();
          //   // 计算两个时间戳之间的差异（以毫秒为单位）
          //   let difference = now - userInfo.expiration;
          //   // 将差异转换为小时
          //   let hoursDifference = difference / (1000 * 3600);
          //   // 检查是否超过一小时
          //   if (hoursDifference > 1) {
          //     Access.on(Access.AUTH_SUCCESS, res =>{
          //       that.setStorageSync('1830906985742336' + '08nU8WouBO' + '-token',res)
          //       that.userInfo = res
          //       that.GetLiveInit()
          //     })
          //     return
          //     Access.init({
          //       eventNumber:'1830906985742336',
          //       accessToken: 'Bearer 3504f5cf8554af00f255cc399f533b5d'
          //     })
          //   } else {
          //     that.userInfo = userInfo
          //     that.GetLiveInit()
          //   }
          // } else {
          //   Access.on(Access.AUTH_SUCCESS, res =>{
          //     that.setStorageSync('1830906985742336' + '08nU8WouBO' + '-token',res)
          //     that.userInfo = res
          //     that.GetLiveInit()
          //   })
          //   return
          //   Access.init({
          //     eventNumber:'1830906985742336',
          //     accessToken: 'Bearer 3504f5cf8554af00f255cc399f533b5d'
          //   })
          // }
          // if (!Mudu.Room) {

          UserLiveInfo({ liveId: that.liveId, track: 10366 }).then(result => {
            if (result.Status === 1) {
              that.GetLiveInit(result);
              // PersonnelMine({virtualEventNumber:result.Data.LoginUrl.EventNumber, token: result.Data.AccessToken}).then(resu => {
              //   that.GetLiveInit(result);
              // })
            } else {
              this.$toast({ message: result.Message })
            }
          })

          // that.GetLiveInit();

          this.todaySchedule = this.$route.query.livetype ? agenda[Number(this.$route.query.livetype) - 1] : agenda[0];
          AddPoints({
            visitType: 30,
            name: that.liveId,
            track: this.$route.query.track ? this.$route.query.track : 10366,
          }).then((res) => {
            if (res.Status === 1) {
              if (res.Data === "1") {
                this.isIntegral = true;
                this.integralText = res.Message.replace("获得", "<br>获得");
              }
            }
          });
          // } else {
          //   window.location.reload();
          // }
        }
      });

      // const dates = [];
      // let date = "";
      // this.agenda.map((item) => {
      //   date = item.date.replace("月", "-").replace("日", "");
      //   date = Date.parse("2022-" + date);
      //   dates.push(date);
      // });
      // const index = dates.findIndex((item) => item >= Date.now());
      // if (index !== -1) {
      //   if (index > 0) {
      //     this.todaySchedule = agenda[index - 1];
      //   } else {
      //     this.todaySchedule = agenda[0];
      //   }
      // } else {
      //   this.todaySchedule = agenda[agenda.length - 1];
      // }
    },
    async GetLiveInit(params) {
      // Watch.Init(Number(this.liveId), () => {
      //   console.log("初始化成功");
      //   this.allInit();
      // });
      await Watch.init({
        // 测试
        accessKeyId: 'MDN14lzzdMY9F80qJ78',
        secretAccessKey: 'HsYimhyJiD7nkJGMOzqEw8nHphe7EAWZIbyFyQBCnuJAGHLi810BGjZHukLDl3dm',

        // 正式
        // accessKeyId:'',
        // secretAccessKey:'',

        accessToken: params.Data.AccessToken.replace('Bearer ', ''),
        refreshToken: params.Data.RefreshToken.replace('Bearer ', ''),
        "expires": params.Data.Expires,
        "eventId": params.Data.LoginUrl.EventId,
        "eventNumber": params.Data.LoginUrl.EventNumber,

        // eventNumber: that.liveId,
        roomNumber: params.Data.LoginUrl.RoomUrls[0].RoomNumber,
        // accessToken: 'a1157f5a749086afb9ef11f7e349798c',
        // refreshToken: '',
        expiration: params.Data.Expires,
        playerDomId: 'J_prismPlayer',
        boardDomId: 'J_prismPlayer',
      }).then(res => {
        console.log('初始化成功');
        console.log(res)
        this.allInit();
      })
    },
    // 初始化播放器
    GetPlayer() {
      if (window._player) {
        window._player.remove();
        window._player = null;
      }
      window._player = new Mudu.Player({
        containerId: "J_prismPlayer", //容器id
        isLive: !!Mudu.Room.GetLiveStatus(), //直播状态
        src: this.liveInfo.liveAttr, //直播地址
        image: this.liveInfo.liveImage,//直播海报
        autoplay: false,//自动播放
        width: this.clientWidth > 750 ? 820.8 : "100%",
        height: this.clientWidth > 750 ? 461.7 : "auto",
        x5Layer: false,
        x5Inline: false,
      });
      this.showPlayBtn = true;
    },
    // 加载直播数据
    allInit() {
      // 开启评论监听
      // this.WatchComment();
      // this.WatchTopic();
      // 同步用户信息
      // Mudu.Room.User.Assign(
      //   this.userInfo.Name,
      //   "https://staticdn.ht-s.cn/se/ciif/2024/personal/icon_person.png",
      //   this.userInfo.OpenId,
      //   (res) => { this.liveUserInfo = res; }
      // );
      // 获取直播间信息
      // let timer = null;
      clearInterval(this.timer);
      // 获取当前观看量
      // GetOnlineVisitorList({ liveId: Number(this.liveId) }).then((res) => {
      //   if (res.errcode == 1000) {
      //     this.liveInfo.viewNums = res.data.count;
      //   }
      // });

      // this.timer = setInterval(async () => {
      //   await GetOnlineVisitorList({ liveId: Number(this.liveId) }).then((res) => {
      //       if (res.errcode == 1000) {
      //         this.liveInfo.viewNums = res.data.count;
      //       }
      //     }
      //   );
      // }, 10000);
      this.liveInfo.liveImage = "https://events.schneider-electric.cn/ciif2023/Api/img/liveBack.png";
      // 获取聊天互动
      this.commentLoading = false
      // this.getComments();
      this.$nextTick(() => {
        // this.GetPlayer();
      });
    },
    // 评论滚动加载
    commentsScroll() {
      const scrollBox = document.querySelector(".comments-content  .el-scrollbar__wrap");
      this.$nextTick(() => {
        // @ 评论盒子高度

        let COMMENT_BOX_HEIGHT, LIVE_HEIGHT;
        // @ 聊天窗口高度

        console.log(COMMENT_BOX_HEIGHT);
        let flag = false;
        // 判断是否滑动到底部
        scrollBox.addEventListener("scroll", () => {
          COMMENT_BOX_HEIGHT = document.querySelector(".comments-content  .el-scrollbar__view").clientHeight;
          LIVE_HEIGHT = document.querySelector(".comments-content  .el-scrollbar__wrap").clientHeight;
          if (scrollBox.scrollTop >= COMMENT_BOX_HEIGHT - LIVE_HEIGHT + 40) {
            if (!flag) {
              flag = true;
              // this.GetMoreComment();
            }
          } else {
            flag = false;
            return false;
          }
        });
      });
    },
    // 获取评论列表
    getComments() {
      console.log(this.liveId);
      this.liveInfo.comments = [];
      const chatListRes = this.ChatList
      console.log(chatListRes)
      this.liveInfo.comments = chatListRes
      const scrollBox = document.querySelector(".comments-content  .el-scrollbar__wrap");
      scrollBox.scrollTop = 0;
      // 获取页数
      // this.liveInfo.commentPage = Mudu.Room.Comment.GetPage();
      // Mudu.Room.Comment.Get(this.liveInfo.commentPage, (res) => {
      //   res = JSON.parse(res);
      //   if (res.status === "y") {
      //     // @ 监听滚动的DOM
      //     const scrollBox = document.querySelector(".comments-content  .el-scrollbar__wrap");
      //     let data1 = res.data.comments.filter(item => item.top == 1)
      //     let data2 = res.data.comments.filter(item => item.top != 1)
      //     this.liveInfo.comments = [...data1, ...data2];
      //     // this.liveInfo.comments = res.data.comments;

      //     // @ 默认滚动到最底部
      //     scrollBox.scrollTop = 0;
      //   }
      //   if (res.status === "n") {
      //     console.log("获取评论失败");
      //   }
      // });
    },
    // 获取更多评论
    async GetMoreComment() {
      const chatListRes = await Chat.fetchHistory()
      this.liveInfo.comments = chatListRes
      scrollBox.scrollTop = 0;
      return
      const AllPage = Math.ceil(this.liveInfo.comments.length / 20);
      if (AllPage < this.liveInfo.commentPage) {
        if (this.active == 0) {
          this.loadMore = true;
        }
        console.log(this.liveInfo.commentPage - AllPage);
        Mudu.Room.Comment.Get(this.liveInfo.commentPage - AllPage, (res) => {
          res = JSON.parse(res);
          if (res.status === "y") {
            const newComments = res.data.comments;
            this.liveInfo.comments = this.liveInfo.comments.concat(newComments);

            this.$nextTick(() => {
              this.loadMore = false;
            });
          }
          if (res.status === "n") {
            this.GetMoreComment();
          }
        });
      }
    },
    // 发送评论
    sendComment() {
      const obj = { event: "trk", ec: "interaction", ea: "chatsent", el: "sent", };
      dataLayer.push(JSON.parse(JSON.stringify(obj)));
      if (this.commentText.trim() === "") {
        this.$toast({ message: "评论不能为空!", getContainer: ".comments-content", });
        return false;
      }
      this.sendLoading = true;
      Chat.sendChat(this.commentText).then((res) => {
        // res = JSON.parse(res);
        this.commentText = "";
        this.$toast({ message: "发送成功", getContainer: ".comments-content", });
        this.sendLoading = false;
        return
        if (res.code === "200") {
          this.commentText = "";
          this.$toast({ message: "发送成功", getContainer: ".comments-content", });
          this.sendLoading = false;
        } else {
          this.$toast({ message: "发送失败，错误码为：" + res.flag, getContainer: ".comments-content", });
          this.sendLoading = false;
        }
      }).catch((err) => {
        console.log(err);
      });
      return
      Mudu.Room.Comment.Send(this.commentText, (res) => {
        res = JSON.parse(res);
        if (res.status === "y") {
          this.commentText = "";
          this.$toast({ message: "发送成功", getContainer: ".comments-content", });
          this.sendLoading = false;
        }
        if (res.status === "n") {
          this.$toast({ message: "发送失败，错误码为：" + res.flag, getContainer: ".comments-content", });
          this.sendLoading = false;
        }
      });
    },
    // !发送表情评论
    setEmojiComment(emoji) {
      // this.commentText += emoji;
      // this.liveInfo.emojiAlert = false;
      const obj = { event: "trk", ec: "interaction", ea: "chatsent", el: "sent", };
      dataLayer.push(JSON.parse(JSON.stringify(obj)));
      Chat.sendChat(emoji).then(() => {
        this.liveInfo.emojiAlert = false;
      }).catch((err) => {
        console.log(err);
      });
      return
      Mudu.Room.Comment.Send(emoji, (res) => {
        this.liveInfo.emojiAlert = false;
      });
    },
    // !监听评论变化
    WatchComment() {
      Chat.on(Chat.CHAT_LIST_UPDATED, res => {
        const { isFirst, direction, chatList: _chatList } = res;
        console.log(res)
        res = JSON.parse(res);
        let data1 = this.liveInfo.comments.filter(item => item.top == 1)
        let data2 = this.liveInfo.comments.filter(item => item.top != 1)
        data2.unshift(res)
        this.liveInfo.comments = [...data1, ...data2];
        // this.liveInfo.comments.unshift(res);
        this.$nextTick(() => {
          // @ 监听滚动的DOM
          const scrollBox = document.querySelector(".comments-content  .el-scrollbar__wrap");
          if (res.visitor_id === this.liveUserInfo.user.hash_id) {
            // @ 默认滚动到最底部
            scrollBox.scrollTop = 0;
          }
        });
      })
      return
      Mudu.MsgBus.On(
        // 事件名，值为Comment.New
        "Comment.New",
        // 事件处理函数，参数为新的评论，类型为object
        (res) => {
          res = JSON.parse(res);
          let data1 = this.liveInfo.comments.filter(item => item.top == 1)
          let data2 = this.liveInfo.comments.filter(item => item.top != 1)
          data2.unshift(res)
          this.liveInfo.comments = [...data1, ...data2];
          // this.liveInfo.comments.unshift(res);
          this.$nextTick(() => {
            // @ 监听滚动的DOM
            const scrollBox = document.querySelector(".comments-content  .el-scrollbar__wrap");
            if (res.visitor_id === this.liveUserInfo.user.hash_id) {
              // @ 默认滚动到最底部
              scrollBox.scrollTop = 0;
            }
          });
        }
      );
    },
    topicsScroll() {
      // @ 监听滚动的DOM
      const scrollBox = document.querySelector(".topics-content  .el-scrollbar__wrap");
      let flag = false;
      // @ 评论盒子高度
      scrollBox.addEventListener("scroll", () => {
        const TOPIC_BOX_HEIGHT = document.querySelector(".topics-content  .el-scrollbar__view").clientHeight;
        // @ 聊天窗口高度
        const LIVE_HEIGHT = document.querySelector(".topics-content  .el-scrollbar__wrap").clientHeight;
        if (scrollBox.scrollTop >= TOPIC_BOX_HEIGHT - LIVE_HEIGHT && TOPIC_BOX_HEIGHT - LIVE_HEIGHT >= 0) {
          if (!flag) {
            this.GetMoreTopic();
            flag = true;
          }
        } else {
          flag = false;
          return false;
        }
      });
    },
    // 获取话题列表
    getTopics() {
      this.liveInfo.topics = [];
      Topic.fetchTopicList();
      return
      this.liveInfo.topicPage = Mudu.Room.Topic.GetPage();
      Mudu.Room.Topic.Get(1, (res) => {
        res = JSON.parse(res);
        console.log(res)
        if (res.status === "y") {
          // @ 监听滚动的DOM
          const scrollBox = document.querySelector(".topics-content  .el-scrollbar__wrap");
          const scrollBox1 = document.querySelector(".comments-content  .el-scrollbar__wrap");
          scrollBox.scrollTop = 0;
          scrollBox1.scrollTop = 0;
          this.liveInfo.topics = res.topics;
          if (!this.topicFlag) {
            this.topicFlag = true;
            this.topicsScroll();
          }
        }
        if (res.status === "n") {
          console.log("获取评论失败");
        }
      });
    },
    // 获取与我相关话题列表
    getMyTopics() {
      this.liveInfo.myTopics = []
      this.liveInfo.topicPage = Mudu.Room.Topic.GetPage();
      let topicPage = Mudu.Room.Topic.GetPage();
      for (var i = 1; i <= topicPage; i++) {
        Mudu.Room.Topic.Get(i, (res) => {
          res = JSON.parse(res);
          // console.log(res)
          if (res.status === "y") {
            res.topics.forEach(item => {
              if (item.username == this.userInfo.Name) {
                this.liveInfo.myTopics.push(item)
              } else {
                let repList = item.replies.filter(val => { return val.username == this.userInfo.Name })
                if (repList.length > 0) {
                  this.liveInfo.myTopics.push(item)
                }
              }
            })
          }
          if (res.status === "n") {
            console.log("获取评论失败");
          }
        });
      }
    },
    // 获取更多话题
    GetMoreTopic() {
      Topic.fetchTopicList();
      return
      const AllPage = Math.ceil(this.liveInfo.topics.length / 10);
      if (AllPage < this.liveInfo.topicPage) {
        if (this.active == 1) {
          this.loadMore = true;
        }
        Mudu.Room.Topic.Get(AllPage + 1, (res) => {
          res = JSON.parse(res);
          if (res.status === "y") {
            const newTopics = res.topics;
            this.liveInfo.topics = this.liveInfo.topics.concat(newTopics);

            this.$nextTick(() => {
              this.loadMore = false;
            });
          }
          if (res.status === "n") {
            this.GetMoreTopic();
          }
        });
      }
    },
    // 回复话题
    replayTopic(item) {
      this.topicText = "";
      this.topicPlaceholder = "回复 " + item.username + "：";
      this.replayTopicId = item.id;
    },
    // 取消回复
    replyCancel() {
      this.replayTopicId = "";
      this.topicText = "";
      this.topicPlaceholder = "请在此处输入您的问题";
    },
    // 发送话题
    async sendTopic() {
      const obj = { event: "trk", ec: "interaction", ea: "answersent", el: "sent", };
      dataLayer.push(JSON.parse(JSON.stringify(obj)));
      // 提问
      if (this.topicPlaceholder === "请在此处输入您的问题") {
        if (this.topicText.trim() === "") {
          this.$toast({ message: "问题不能为空!", getContainer: ".topics-content", });
          return false;
        }
        this.sendLoading = true;
        try {
          await Topic.submitTopic([], this.topicText);
          this.topicText = "";
          this.$toast({ message: "发送成功", getContainer: ".topics-content", });
          this.sendLoading = false;
        } catch (error) {
          if (error.code) {
            if (error.code === 420007) {
              message.success(error.message);
            } else {
              message.error(error.message);
            }
          }
        }
        // res = JSON.parse(res);
        // if (res.status === "y") {
        //   this.topicText = "";
        //   this.$toast({ message: "发送成功", getContainer: ".topics-content", });
        //   this.sendLoading = false;
        // }
        // if (res.status === "n") {
        //   this.$toast({ message: "发送失败，错误码为：" + res.flag, getContainer: ".topics-content", });
        //   this.sendLoading = false;
        // }
        return
        Mudu.Room.Topic.SendTopic({ msg: this.topicText, }, (res) => {
          res = JSON.parse(res);
          if (res.status === "y") {
            this.topicText = "";
            this.$toast({ message: "发送成功", getContainer: ".topics-content", });
            this.sendLoading = false;
          }
          if (res.status === "n") {
            this.$toast({ message: "发送失败，错误码为：" + res.flag, getContainer: ".topics-content", });
            this.sendLoading = false;
          }
        }
        );
        // 回复
      } else {
        if (this.topicText.trim() === "") {
          this.$toast("回复内容不能为空!");
          return false;
        }
        this.sendLoading = true;
        let res = await Topic.submitReply(this.replayTopicId, this.topicText);
        res = JSON.parse(res);
        if (res.status === "y") {
          this.topicText = "";
          this.$toast("发送成功");
          this.sendLoading = false;
        }
        if (res.status === "n") {
          this.$toast("发送失败，错误码为：" + res.flag);
          this.sendLoading = false;
        }
        return
        Mudu.Room.Topic.SendReply({ topicId: this.replayTopicId, msg: this.topicText, }, (res) => {
          res = JSON.parse(res);
          if (res.status === "y") {
            this.topicText = "";
            this.$toast("发送成功");
            this.sendLoading = false;
          }
          if (res.status === "n") {
            this.$toast("发送失败，错误码为：" + res.flag);
            this.sendLoading = false;
          }
        }
        );
      }
    },
    // !监听话题变化
    WatchTopic() {
      return
      Mudu.MsgBus.On(
        // 事件名，值为Topic.New
        "Topic.New",
        // 事件处理函数，参数为新的评论，类型为object
        (res) => {
          res = JSON.parse(res);
          this.liveInfo.topics.unshift(res);
        }
      );
      Mudu.MsgBus.On(
        // 事件名，值为Topic.Reply.New
        "Topic.Reply.New",

        // 事件处理函数，参数为新收到的reply
        (res) => {
          res = JSON.parse(res);
          console.log(res);
          const index = this.liveInfo.topics.findIndex((item) => item.id == res.belong_to);
          if (index !== -1) {
            this.liveInfo.topics[index].replies.push(res);
          }
        }
      );
    },
    // 互动tab切换
    tabChange(i) {
      // if (!this.interactionLoading) {
      this.active = i;
      this.loadMore = false;
      this.commentLoading = true
      setTimeout(() => {
        this.commentLoading = false
      }, 1000)
      if (i === 0) {
        // 获取聊天互动
        // this.getComments();
      } else if (i === 1) {
        // 获取专家解答
        // this.getTopics();
      } else if (i === 2) {
        this.getMyTopics();
      }
      // } else {
      //   this.$toast("请耐心等待加载完成！");
      // }
    },
    // emoji转换
    getMessage(message) {
      let flag = false;
      this.liveInfo.emojiList.map((item) => {
        if (message.indexOf(item.text) !== -1) {
          flag = true;
        }
      });
      if (!flag) {
        return message;
      } else {
        this.liveInfo.emojiList.map((item) => {
          message = message.replaceAll(item.text, `<img src="${item.url}" />`);
        });
        return message;
      }
    },
    // 关闭弹窗
    boxClose() {
      const obj = { event: "trk", ec: "popup", ea: "close", el: "close", };
      dataLayer.push(JSON.parse(JSON.stringify(obj)));
      this.question_box_show = false;
    },
    handleClose() {
      this.isRegister = false;
      this.isOk = false;
      this.isError = false;
      this.isSuccess = false;
      this.isIntegral = false;
    },
    handleReset() {
      this.isError = false;
      if (this.questionType === "radio") {
        this.currentSelect = -1;
      } else {
        this.currentSelect = [];
      }
      this.question_box_show = true;
    },
    // 参与问答赢积分
    toExam(answerNo) {
      this.answerNo = answerNo
      // // if (this.$store.state.islogin) {
      // // this.articleCode = item.code;
      // // if (item.question.title.indexOf("多选题") === -1) {
      // //   this.questionType = "radio";
      // //   this.currentSelect = -1;
      // // } else {
      // //   this.currentSelect = [];
      // //   this.questionType = "checkbox";
      // // }
      // console.log(this.userInfo);
      GetLinkExamination({
        answerno: answerNo,
        track: this.$route.query.track,
      }).then((res) => {
        if (res.Status === 1) {
          this.question = res.Data[0];
          if (this.question.isCorrect) {
            this.isSuccess = true;
          } else {
            if (this.question.Type === "radio") {
              this.currentSelect = -1;
            } else {
              this.currentSelect = [];
            }
            this.question_box_show = true;
          }
        }
      });
    },
    // 提交答题
    confirm() {
      if (!this.$store.state.load) {
        if (this.currentSelect !== -1 && this.currentSelect.length !== 0) {
          this.$store.commit("load", true);
          let answer = "";
          if (typeof this.currentSelect === "number") {
            switch (this.currentSelect) {
              case 0:
                answer = "A";
                break;
              case 1:
                answer = "B";
                break;
              case 2:
                answer = "C";
                break;
              case 3:
                answer = "D";
                break;
              case 4:
                answer = "E";
                break;
              case 5:
                answer = "F";
                break;
              case 6:
                answer = "G";
                break;
              case 7:
                answer = "H";
                break;
            }
          } else {
            this.currentSelect = this.currentSelect.join(",");
            this.currentSelect = this.currentSelect.replace("0", "A");
            this.currentSelect = this.currentSelect.replace("1", "B");
            this.currentSelect = this.currentSelect.replace("2", "C");
            this.currentSelect = this.currentSelect.replace("3", "D");
            this.currentSelect = this.currentSelect.replace("4", "E");
            this.currentSelect = this.currentSelect.replace("5", "F");
            this.currentSelect = this.currentSelect.replace("6", "G");
            this.currentSelect = this.currentSelect.replace("7", "H");
            answer = this.currentSelect;
          }

          this.question_box_show = false;
          SubmitLinkExamination(
            {
              Id: this.question.Id,
              answer: answer,
              answerCode: this.answerNo
            },
            this.$route.query.track ? this.$route.query.track : "10366"
          ).then((res) => {
            setTimeout(() => {
              this.$store.commit("load", false);
              if (res.Status === 1) {
                this.isError = true;
              } else if (res.Status === 2) {
                this.isOk = true;
              } else if (res.Status === -99) {
                this.isSuccess = true;
              }
            }, 500);
          });
        } else {
          this.$toast("请选择一个选项！");
        }
      }
    },
    // 分享直播
    shareLive() {
      this.$store.state.load = true;
      GetSharePoster({
        openId: this.userInfo.OpenId,
        mobile: this.userInfo.Phone,
        mailBox: this.userInfo.Email,
        gongBoId: this.$route.query.livetype == 4 ? 10430 : (this.$route.query.livetype ? Number(this.$route.query.livetype) + 10426 : 10427),
        number: this.$route.query.livetype == 4 ? 4 : (this.$route.query.livetype ? Number(this.$route.query.livetype) : 1),
      }).then((res) => {
        if (res.code === "OK") {
          this.posterImg = res.message;
          this.posterShow = true;
          GetUserLogs({
            visitName: "分享",
            visitType: 5,
            url: window.location.href,
            track: this.$route.query.track ? this.$route.query.track : 10366,
          });
        } else {
          this.$toast(res.message);
        }
        this.$store.state.load = false;
      });
    },
    closePoster(e) {
      this.posterShow = false;
    },
    // 存储数据
    setStorageSync(key, data) {
      try {
        if (typeof data === 'object') {
          // 如果数据是对象类型，则先转换成字符串再存储
          data = JSON.stringify(data);
        }
        localStorage.setItem(key, data);
        return true;
      } catch (e) {
        console.error('Error setting item to localStorage:', e);
        return false;
      }
    },
    // 获取数据
    getStorageSync(key) {
      try {
        const value = localStorage.getItem(key);
        if (value) {
          try {
            // 尝试将字符串解析回对象
            return JSON.parse(value);
          } catch (e) {
            // 如果不是JSON格式的数据，则直接返回字符串
            return value;
          }
        }
      } catch (e) {
        console.error('Error getting item from localStorage:', e);
      }
      return null;
    }
  },
  computed: {
    clientWidth() {
      return this.$store.state.clientWidth;
    },
    islogin() {
      return this.$store.state.islogin;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
    interactionLoading() {
      let flag = true;
      if (this.active === 0) {
        if (this.liveInfo.commentPage > 0) {
          if (this.liveInfo.comments.length !== 0) {
            flag = false;
          }
        } else {
          flag = false;
        }
      } else if (this.active === 1) {
        if (this.liveInfo.topicPage > 0) {
          if (this.liveInfo.topics.length !== 0) {
            flag = false;
          }
        } else {
          flag = false;
        }
      } else if (this.active === 2) {
        if (this.liveInfo.topicPage > 0) {
          if (this.liveInfo.myTopics.length !== 0) {
            flag = false;
          }
        } else {
          flag = false;
        }
      }
      return flag || !this.liveUserInfo.user.hash_id;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>